import './styles.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Input,
  Text,
  useBreakpointValue,
  useMediaQuery,
  useToast
} from '@chakra-ui/react';
import {
  addDays,
  addHours,
  format,
  formatISO,
  isValid,
  parse,
  subDays,
  subHours,
  toDate
} from 'date-fns';
import { enUS, ptBR } from 'date-fns/locale';
import pt from 'date-fns/locale/pt';
import { useState } from 'react';
import { Calendar } from 'react-date-range';
import { DateRange, RangeKeyDict } from 'react-date-range';
import { AiOutlineInfoCircle } from 'react-icons/ai';

type DatePickerExport = {
  startDate?: string;
  setStartDate?: any;
  endDate?: string;
  setEndDate?: any;
  maxInterval?: number;
  isOpen?: boolean;
  type?: string;
  isMobile?: boolean;
  time?: string;
  uniqueDate?: boolean;
  onExport?: (
    tipo: string,
    data_inicial: string,
    data_fim: string
  ) => Promise<void>;
  setTime?: React.Dispatch<React.SetStateAction<any>>;
  setIsOpen?: React.Dispatch<React.SetStateAction<any>>;
};

export const DatePickerExport = ({
  startDate = subDays(new Date(), 7).toISOString(),
  setStartDate,
  isMobile,
  endDate = new Date().toISOString(),
  setEndDate,
  uniqueDate,
  time,
  setTime,
  isOpen = false,
  onExport,
  setIsOpen,
  type
}: DatePickerExport) => {
  const toast = useToast();

  const [dateState, setDateState] = useState<any>([
    {
      startDate: new Date(startDate).setHours(0),
      endDate: new Date(endDate).setHours(23),
      key: 'selection'
    }
  ]);

  const [uniqueDateState, setUniqueDateState] = useState<any>(null);

  const handleSetDate = (item: RangeKeyDict) => {
    setDateState([
      {
        startDate: item.selection.startDate,
        endDate: item.selection.endDate,
        key: 'selection'
      }
    ]);
  };

  const handleApplyDates = async () => {
    if (uniqueDate == true) {
      setStartDate(uniqueDateState);
    } else {
      setStartDate(dateState[0].startDate);
      setEndDate(dateState[0].endDate);
    }
    if (type === 'direct-export') {
      await onExport(
        'data-criacao',
        dateState[0].startDate,
        dateState[0].endDate
      );
    }
    setIsOpen(false);
  };

  const formatDateValue = (date, type, where) => {
    if (date === null) {
      return;
    }
    if (where === 'inicio') {
      if (type === 'apresentar') {
        const formatedDate = format(new Date(date), 'yyyy-MM-dd');
        return formatedDate;
      }
      if (date && isValid(parse(date, 'yyyy-MM-dd', Date.now()))) {
        if (type === 'retornar') {
          setDateState([
            {
              ...dateState[0],
              startDate: parse(date, 'yyyy-MM-dd', Date.now())
            }
          ]);
          if (uniqueDate === true) {
            setUniqueDateState(parse(date, 'yyyy-MM-dd', Date.now()));
          }
        }
      }
    }

    if (where === 'fim') {
      if (type === 'apresentar') {
        const formatedDate = format(new Date(date), 'yyyy-MM-dd');
        return formatedDate;
      }
      if (date && isValid(parse(date, 'yyyy-MM-dd', Date.now()))) {
        if (type === 'retornar') {
          setDateState([
            { ...dateState[0], endDate: parse(date, 'yyyy-MM-dd', Date.now()) }
          ]);
        }
      }
    }
    return null;
  };

  const handleCleanFilters = () => {
    setDateState([
      {
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(),
        key: 'selection'
      }
    ]);
    setUniqueDateState(null);
    setStartDate(null);
    setEndDate(null);
    setIsOpen(false);
  };

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  });

  return (
    <Box
      position="absolute"
      bottom={uniqueDate === true ? '' : '7'}
      top={uniqueDate === true ? '0.2' : ''}
      zIndex={100}
    >
      {isOpen ? (
        <Box
          h="100%"
          backgroundColor="#fff"
          boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
        >
          <Flex h="100%">
            {uniqueDate !== true ? (
              <DateRange
                onChange={(item) => handleSetDate(item)}
                ranges={dateState}
                monthDisplayFormat="MMMM yyyy"
                weekdayDisplayFormat="EEEEE"
                editableDateInputs={true}
                months={1}
                locale={pt}
                direction={'horizontal'}
              />
            ) : (
              <Calendar
                ranges={dateState}
                monthDisplayFormat="MMMM yyyy"
                weekdayDisplayFormat="EEEEE"
                editableDateInputs={true}
                date={uniqueDateState}
                onChange={(e) => {
                  setUniqueDateState(e);
                }}
                months={1}
                locale={pt}
                direction={'horizontal'}
              />
            )}

            {isMobile !== true && (
              <>
                <Divider h="24.5rem" orientation="vertical" />

                <Box mt="1.2rem" display={'flex'} flexDir="column">
                  <Box px="0.5rem">
                    <Text
                      bg="#D3DEED"
                      textAlign={'center'}
                      fontWeight="bold"
                      color="#146CFA"
                      fontSize={'1rem'}
                      borderRadius="0.5rem"
                    >
                      Período Customizado
                    </Text>
                  </Box>
                  <Box mt="2rem" px="1rem">
                    <Text fontSize={'0.8rem'}>
                      {uniqueDate ? 'Data do agendamento' : 'Início'}
                    </Text>
                    <Input
                      borderRadius="2rem"
                      type="date"
                      p="0.2rem"
                      variant={'unstyled'}
                      // isDisabled={true}
                      onChange={(e) => {
                        formatDateValue(e.target.value, 'retornar', 'inicio');
                      }}
                      border="1px solid #001E64"
                      value={
                        uniqueDate === true
                          ? formatDateValue(
                              uniqueDateState,
                              'apresentar',
                              'inicio'
                            )
                          : formatDateValue(
                              dateState[0].startDate,
                              'apresentar',
                              'inicio'
                            )
                      }
                      placeholder="__/__/____"
                    />
                  </Box>
                  {uniqueDate !== true && (
                    <Box mt="1rem" px="1rem">
                      <Text>Término</Text>
                      <Input
                        borderRadius="2rem"
                        type="date"
                        p="0.2rem"
                        border="1px solid #001E64"
                        variant={'unstyled'}
                        // isDisabled={true}
                        onChange={(e) => {
                          formatDateValue(e.target.value, 'retornar', 'fim');
                        }}
                        value={formatDateValue(
                          dateState[0].endDate,
                          'apresentar',
                          'fim'
                        )}
                        placeholder="__/__/____"
                      />
                    </Box>
                  )}
                  {uniqueDate === true && (
                    <>
                      <Text px={'1rem'} mt="4" fontSize={'0.8rem'}>
                        Horário
                      </Text>
                      <div className="tw-flex tw-items-center tw-gap-1 tw-justify-center ">
                        <input
                          className=" tw-border-[#001E64] tw-border-[0.1rem] tw-w-[85%] tw-px-1 tw-py-1 tw-rounded-full  tw-bg-white"
                          value={time}
                          onChange={(e) => {
                            console.log(e.target.value);
                            setTime(e.target.value);
                          }}
                          type={'time'}
                        />
                      </div>
                    </>
                  )}
                </Box>
              </>
            )}
          </Flex>

          <Divider />

          <Flex alignItems="center" justifyContent="space-between" p="1rem">
            <Flex
              justifyContent="space-between"
              alignItems={'space-between'}
              flexDir={isMobile ? 'column-reverse' : 'row'}
              gap={isMobile ? 2 : 0}
              w="100%"
            >
              <Button
                color="red"
                bg="white"
                border="1px solid red"
                borderRadius="24px"
                onClick={() => {
                  handleCleanFilters();
                }}
              >
                Limpar Filtro
              </Button>
              <Flex gap={2} flexDir={isMobile ? 'column-reverse' : 'row'}>
                <Button
                  borderRadius="24px"
                  w={isMobile ? '100%' : '9rem'}
                  border="1px solid #001E64"
                  bg="#fff"
                  onClick={() => setIsOpen(false)}
                  color="#001E64"
                >
                  Cancelar
                </Button>
                {/* <Button
                  onClick={handleApplyDates}
                  borderRadius="24px"
                  w={isMobile ? '100%' : '9rem'}
                  bg="#001E64"
                  color="#fff"
                  _hover={{
                    opacity: 0.8
                  }}
                >
                  {type !== 'direct-export' ? 'Aplicar' : 'Exportar'}
                </Button> */}
                <button
                  onClick={handleApplyDates}
                  className="tw-h-[2.7rem] tw-w-full tw-rounded-[24px] tw-bg-[#001E64] tw-text-[#fff]"
                >
                  {type !== 'direct-export' ? 'Aplicar' : 'Exportar'}
                </button>
              </Flex>
            </Flex>
          </Flex>
        </Box>
      ) : null}
    </Box>
  );
};
